module.exports = __webpack_public_path__ + "img/bandcamp.d2e28d32.png";